import { currentCartItemActions } from '../../services';

export const currentCartItemDispatcher = dispatch => ( {
  showCartItemActions: ( item ) => dispatch( { type: currentCartItemActions.SHOW, item} ),
  hideCartItemActions: ()=> dispatch({type: currentCartItemActions.HIDE})
} );